import React from "react";
import logo from "../assets/images/logo.png";
import avatarPlaceHolder from "../assets/images/avatarPlaceholder.png";
import storeInit from "../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import { setbypassSmileIdLiveCheck, setUseLivenessCheck } from "../redux/features/oxygen/oxygenRetailSlice";

const Header = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user?.user);
  const livenessCheck = useSelector((state) => state.oxygenRetail?.useLivenessCheck);
  const bypassSmileIdLiveCheck = useSelector((state) => state.oxygenRetail?.bypassSmileIdLiveCheck);
  console.log("bypassSmileIdLiveCheck", bypassSmileIdLiveCheck);
  const signOut = (e) => {
    e.preventDefault();
    storeInit.persistor.purge();
    window.location.replace("/");
    //  navigate("/")
  };


  return (
    <>
      <div className="header hor-header fixed">
        <div className="container">
          <div className="d-flex">
            <a
              className="animated-arrow hor-toggle horizontal-navtoggle"
                data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample"
            >
              <span />
            </a>
            <div>
              <NavLink className="header-brand1" to="/dashboard">
                <img
                  src={logo}
                  className="header-brand-img desktop-logo"
                  alt="logo"
                />
                <img
                  src={logo}
                  className="header-brand-img light-logo"
                  alt="logo"
                />
              </NavLink>
              {/* LOGO */}
            </div>
            <div className="d-flex  ml-auto header-right-icons header-search-icon">
              <div className="dropdown d-md-flex pt-4">
                STORE: &nbsp;{" "}
                <span className="text-danger">{user?.store_name}</span>
              </div>

              <div className="dropdown d-md-flex">
                <a className="nav-link icon full-screen-link nav-link-bg">
                  <i className="fe fe-maximize fullscreen-button" />
                </a>
              </div>

              <div className="dropdown profile-1">
                <a
                  href=""
                  data-toggle="dropdown"
                  className="nav-link pr-2 leading-none d-flex"
                >
                  <span>
                    <img
                      src={avatarPlaceHolder}
                      alt="profile-user"
                      className="avatar  profile-user brround cover-image"
                    />
                  </span>
                </a>
                <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
                  <div className="drop-heading">
                    <div className="text-center">
                      <h5 className="text-dark mb-0">
                        {user?.firstname} {user?.lastname}
                      </h5>
                      <small className="text-muted">{user.role}</small>
                    </div>
                  </div>
                  <div className="dropdown-divider m-0" />
                  <a className="dropdown-item" href="">
                    <i className="dropdown-icon mdi mdi-account-outline" />{" "}
                    Reset Password
                  </a>

                  <a className="dropdown-item" onClick={signOut}>
                    <i className="dropdown-icon mdi  mdi-logout-variant" /> Sign
                    out
                  </a>
                </div>
              </div>
              {/* div class="dropdown d-md-flex header-settings">
            <a href="" class="nav-link icon " data-toggle="sidebar-right" data-target=".sidebar-right">
                <i class="fe fe-align-right"></i>
            </a>
        </div */}
              {/* SIDE-MENU */}
            </div>
          </div>
        </div>
      </div>

      <div className="sticky">
        <div className="horizontal-main hor-menu clearfix">
          <div className="horizontal-mainwrapper container clearfix">
            {/*Nav*/}
            <nav className="horizontalMenu clearfix">
              <ul className="horizontalMenu-list">
                <li>
                  <Link to="/" className>
                    <i className="ti-home" /> Dashboard
                  </Link>
                </li>
                {/* <li >
                <Link to="/" className>
                    <i className="ti-home" /> Inventory
                  </Link>
                </li> */}
                <li>
                  <Link to="/" className>
                    <i className="ti-target" /> Status
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/status/onboarded" className>
                        <i className="ti-medall-alt" /> Onboarded
                      </Link>
                    </li>
                    <li>
                      <Link to="/status/inprogress" className>
                        <i className="ti-pulse" /> In Progress
                      </Link>
                    </li>
                    <li
                        onClick={() => dispatch(setbypassSmileIdLiveCheck(!bypassSmileIdLiveCheck))}
                      >
                        <Link to="#" className>
                          <i className="ti-pulse" /> {bypassSmileIdLiveCheck ? "return SmileId" : "bypass SmileId"}
                        </Link>
                    </li>

                    {/* li ><a href="{{ url('/uploads') }}">Uploads</a></li */}
                    {/* li ><a href="">Notifications</a></li */}
                  </ul>
                </li>
                {/* <li>
                  <Link to="/prequalify" className>
                  <i className="ti-package" /> NEW
                  </Link>
                  </li> */}
                  {
                    livenessCheck === 'qoreId' ?(
                      <li 
                        onClick={() => {
                          dispatch(setUseLivenessCheck('smileId'));
                          const offcanvasEl = document.getElementById('offcanvasExample');
                          const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasEl) || new window.bootstrap.Offcanvas(offcanvasEl);
                          bsOffcanvas.hide();
                        }}
                      >
                        <Link to="#" className>
                          <i className="ti-pulse" /> Use SmileId LivenessCheck
                        </Link>
                      </li>
                    ):  livenessCheck === 'smileId' ?(
                      <li 
                        onClick={() => {
                          dispatch(setUseLivenessCheck('qoreId'));
                          const offcanvasEl = document.getElementById('offcanvasExample');
                          const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasEl) || new window.bootstrap.Offcanvas(offcanvasEl);
                          bsOffcanvas.hide();
                        }}
                      >
                        <Link to="#" className>
                          <i className="ti-pulse" /> Use QoreId LivenessCheck
                        </Link>
                      </li>
                    ): null
                  }
              </ul>
            </nav>
            {/*Nav*/}
          </div>
        </div>
      </div>

      <div className="mobile-header hor-mobile-header">
        <div className="container">
          <div className="d-flex">
            <a
              className="animated-arrow hor-toggle horizontal-navtoggle "
                data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample"
            >
              <span />
            </a>
            <NavLink className="header-brand" to="/">
              <img src={logo} className="header-brand-img desktop-logo" />
              <img
                src={logo}
                className="header-brand-img desktop-logo mobile-light"
                alt="logo"
              />
            </NavLink>
            <div className="d-flex order-lg-2 ml-auto header-right-icons">
              {/* <button className="navbar-toggler navresponsive-toggler d-md-none" type="button" data-toggle="collapse" data-target="#navbarSupportedContent-4" aria-controls="navbarSupportedContent-4" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon fe fe-more-vertical text-white" />
        </button> */}
              <div className="dropdown profile-1">
                <a
                  href=""
                  data-toggle="dropdown"
                  className="nav-link pr-2 leading-none d-flex"
                >
                  <span>
                    <img
                      src={avatarPlaceHolder}
                      alt="profile-user"
                      className="avatar  profile-user brround cover-image"
                    />
                  </span>
                </a>
                <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
                  <div className="drop-heading">
                    <div className="text-center">
                      <h5 className="text-dark mb-0">
                        {user?.firstname} {user?.lastname}
                      </h5>
                      <small className="text-muted">{user.role}</small>
                    </div>
                  </div>
                  <div className="dropdown-divider m-0" />
                  <a className="dropdown-item" href="">
                    <i className="dropdown-icon mdi mdi-account-outline" />{" "}
                    Reset Password
                  </a>

                  <a className="dropdown-item" onClick={signOut}>
                    <i className="dropdown-icon mdi  mdi-logout-variant" /> Sign
                    out
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bootstrap Offcanvas for the sidebar */}
      <div
        className="offcanvas offcanvas-start custom-offcanvas offcanvasCustom-top"
        tabIndex="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasExampleLabel">
          </h5>
          <button
            type="button"
            className="btn-close text-reset offcanvasClose-btn"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <ul className="list-unstyled">
            <li>
              <Link to="/" className="dropdown-item">
                <i className="ti-home" /> Dashboard
              </Link>
            </li>
            <li>
              <Link to="/status/onboarded" className="dropdown-item">
                <i className="ti-medall-alt" /> Onboarded
              </Link>
            </li>
            <li>
              <Link to="/status/inprogress" className="dropdown-item">
                <i className="ti-pulse" /> In Progress
              </Link>
            </li>
            <li style={{ cursor: 'pointer', padding: '10px 0px 10px 20px' }}
                onClick={() => 
                {
                  dispatch(setbypassSmileIdLiveCheck(!bypassSmileIdLiveCheck));
                  const offcanvasEl = document.getElementById('offcanvasExample');
                    const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasEl) || new window.bootstrap.Offcanvas(offcanvasEl);
                    bsOffcanvas.hide();
                }
                }
              >
              <i className="ti-pulse" /> {bypassSmileIdLiveCheck ? "return SmileId" : "bypass SmileId"}
              </li>
            {
              livenessCheck === 'qoreId' ? (
                <li style={{ cursor: 'pointer', padding: '10px 0px 10px 20px' }}
                  onClick={() => {
                    dispatch(setUseLivenessCheck('smileId'));
                    const offcanvasEl = document.getElementById('offcanvasExample');
                    const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasEl) || new window.bootstrap.Offcanvas(offcanvasEl);
                    bsOffcanvas.hide();
                  }}
                >
                  <i className="ti-pulse" /> Use SmileId LivenessCheck
                </li>

              ) : livenessCheck === 'smileId' ? (
                <li style={{ cursor: 'pointer', padding: '10px 0px 10px 20px' }}
                  onClick={() => {
                    dispatch(setUseLivenessCheck('qoreId'));
                    const offcanvasEl = document.getElementById('offcanvasExample');
                    const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasEl) || new window.bootstrap.Offcanvas(offcanvasEl);
                    bsOffcanvas.hide();
                  }}
                >
                  <i className="ti-pulse" /> Use QoreId LivenessCheck
                </li>

              ) : null
            }

          </ul>
        </div>
      </div>
    </>
  );
};

export default Header;
